import Modal from '@shared/components/Basic/Modal/Modal'
import Step from '@shared/components/Basic/Modal/Step'
import Header from '@shared/components/Basic/Modal/Header'
import Content from '@shared/components/Basic/Modal/Content'
import Footer from '@shared/components/Basic/Modal/Footer'

export default {
  container: Modal,
  step: Step,
  header: Header,
  content: Content,
  footer: Footer,
}
